import { Button, UIHeading1, Body1 } from '@cian/ui-kit';
import * as React from 'react';
import { NBSP } from 'shared/constants/symbols';

import * as styles from './NewbuildingBrokerConsultantBanner.css';

interface INewbuildingBrokerConsultantBannerProps {
  buttonText?: string;
  buttonLoading: boolean;
  onClick: () => void;
}

export const NewbuildingBrokerConsultantBanner: React.FC<INewbuildingBrokerConsultantBannerProps> = ({
  buttonText = 'К заявке',
  buttonLoading,
  onClick,
}) => {
  return (
    <section className={styles['container']} data-testid="BrokerBanner">
      <div className={styles['inner']}>
        <UIHeading1>
          Подберём и{NBSP}поможем купить квартиру в{NBSP}новостройке. Бесплатно!
        </UIHeading1>
        <div className={styles['description-wrapper']}>
          <Body1>
            Найдём тот{NBSP}самый вариант под{NBSP}ваш{NBSP}бюджет
          </Body1>
        </div>
        <div>
          <Button theme="fill_primary" loading={buttonLoading} onClick={onClick}>
            {buttonText}
          </Button>
        </div>
      </div>
    </section>
  );
};
